import React from "react";
import Header from "../../components/layout/Header/Header";
import { Container, H1, HeaderText, MainText, Br, Ul } from "./styles";
import Footer from "../../components/layout/Footer/Footer";

const Policy = () => {
  return (
    <>
      <Container>
        <H1>Политика защиты и обработки персональных данных</H1>
        <HeaderText>1. Общие положения</HeaderText>
        <MainText>
          {
            "1.1. Настоящая Политика в отношении обработки персональных данных (далее - Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» (далее – Закон о персональных данных) в целях обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну."
          }
          <Br />
          {
            "1.2. Политика действует в отношении всех персональных данных, которые обрабатывает Прохорова Любовь Васильевна, 18.09.1998 г. р, место рождения г. Краснодар, паспорт 0320 № 629869, адрес регистрации: город Краснодар, улица Яна Полуяна, д. 42, квартира 26 (далее – «Оператор») и которые получены от посетителей сайта, расположенного по адресу в сети Интернет http://prohorovaconsult.com/."
          }
          <Br />
          {
            "1.3. Политика распространяется на отношения в области обработки персональных данных, возникшие у Оператора как до, так и после утверждения настоящей Политики."
          }
          <Br />
          {
            "1.1. Настоящая Политика в отношении обработки персональных данных (далее - Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» (далее – Закон о персональных данных) в целях обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну. 1.2. Политика действует в отношении всех персональных данных, которые обрабатывает Прохорова Любовь Васильевна, 18.09.1998 г. р, место рождения г. Краснодар, паспорт 0320 № 629869, адрес регистрации: город Краснодар, улица Яна Полуяна, д. 42, квартира 26 (далее – «Оператор») и которые получены от посетителей сайта, расположенного по адресу в сети Интернет http://prohorovaconsult.com/. 1.3. Политика распространяется на отношения в области обработки персональных данных, возникшие у Оператора как до, так и после утверждения настоящей Политики. 1.4. Во исполнение требований ч. 2 ст. 18.1 Закона о персональных данных настоящая Политика расположена в свободном доступе по адресу в сети Интернет:"
          }
        </MainText>
        <HeaderText>2. Термины и принятые сокращения</HeaderText>
        <MainText>
          {
            "Персональные данные (ПД) – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных), оставленная этим лицом на сайте по адресу в сети Интернет http://prohorovaconsult.com/, в частности:"
          }
          <Br />
          <Ul>
            <li>Фамилия, имя, отчество</li>
            <li>Номер телефона</li>
            <li>Адрес электронной почты</li>
            <li>Ссылки на аккаунт в социальных сетях.</li>
          </Ul>
          {
            "Персональные данные, разрешенные субъектом персональных данных для распространения – это персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения. Оператор персональных данных (оператор) – физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными. Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя в том числе:"
          }
          <Br />
          <Ul>
            <li>сбор</li>
            <li>запись</li>
            <li>систематизацию</li>
            <li>накопление</li>
            <li>хранение</li>
            <li>{"уточнение (обновление, изменение)"}</li>
            <li>извлечение</li>
            <li>использование</li>
            <li>{"передачу (предоставление, доступ)"}</li>
            <li>распространение</li>
            <li>обезличивание</li>
            <li>блокирование</li>
            <li>удаление</li>
            <li>уничтожение.</li>
          </Ul>
          {
            "Автоматизированная обработка персональных данных - обработка персональных данных с помощью средств вычислительной техники. Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц. Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных)."
          }
          <Br />
          {
            "Уничтожение персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных. Обезличивание персональных данных – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных."
          }
          <Br />
          {
            "Информационная система персональных данных (ИПСД) – совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку, информационных технологий и технических средств. Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу."
          }
        </MainText>
        <HeaderText>
          3. Порядок и условия обработки и хранения персональных данных
        </HeaderText>
        <MainText>
          {
            "3.1. Обработка персональных данных осуществляется Оператором в соответствии с требованиями законодательства Российской Федерации."
          }
          <Br />
          {
            "3.2. Обработка персональных данных осуществляется с согласия субъектов персональных данных на обработку их персональных данных, а также без такового в случаях, предусмотренных законодательством Российской Федерации."
          }
          <Br />
          {
            "3.3. Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения, оформляется отдельно от иных согласий субъекта персональных данных на обработку его персональных данных."
          }
          <Br />
          {
            "3.4. Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения, может быть предоставлено оператору:"
          }
          <Br />
          <Ul>
            <li>непосредственно</li>
            <li>
              с использованием информационной системы уполномоченного органа по
              защите прав субъектов персональных данных.
            </li>
          </Ul>
          {
            "3.5. Оператор осуществляет как автоматизированную, так и неавтоматизированную обработку персональных данных."
          }
          <Br />
          {"3.6. Обработка персональных данных осуществляется путем:"}
          <Br />
          <Ul>
            <li>
              получения персональных данных в устной и письменной форме
              непосредственно с согласия субъекта персональных данных на
              обработку или распространение его персональных данных
            </li>
            <li>использования иных способов обработки персональных данных.</li>
          </Ul>
          {
            "3.7. Не допускается раскрытие третьим лицам и распространение персональных данных без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом."
          }
          <Br />
          {
            "3.8. Передача персональных данных органам дознания и следствия, в Федеральную налоговую службу, Пенсионный фонд, Фонд социального страхования и другие уполномоченные органы исполнительной власти и организации осуществляется в соответствии с требованиями законодательства Российской Федерации."
          }
          <Br />
          {
            "3.9. Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, распространения и других несанкционированных действий, в том числе:"
          }
          <Br />
          <Ul>
            <li>
              определяет угрозы безопасности персональных данных при их
              обработке
            </li>
            <li>
              создает необходимые условия для работы с персональными данными
            </li>
            <li>организует учет документов, содержащих персональные данные</li>
            <li>
              организует работу с информационными системами, в которых
              обрабатываются персональные данные
            </li>
            <li>
              хранит персональные данные в условиях, при которых обеспечивается
              их сохранность и исключается неправомерный доступ к ним
            </li>
          </Ul>
          {
            "3.10. Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором или соглашением."
          }
          <Br />
          {
            "3.11. При сборе персональных данных, в том числе посредством информационно телекоммуникационной сети интернет, Оператор обеспечивает запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся на территории Российской Федерации, за исключением случаев, указанных в Законе о персональных данных."
          }
          <Br />
          {
            "3.12. Обработке подлежат только персональные данные, которые отвечают целям их обработки."
          }
          <Br />
          {
            "3.13. Обработка Оператором персональных данных осуществляется в следующих целях:"
          }
          <Br />
          <Ul>
            <li>
              обеспечение соблюдения Конституции, федеральных законов и иных
              нормативных правовых актов Российской Федерации
            </li>
            <li>оказание Оператором консультационных услуг</li>
            <li>
              осуществление гражданско-правовых отношений между Оператором и
              субъектом персональных данных
            </li>
          </Ul>
          {
            "3.14. Категории субъектов персональных данных. Обрабатываются ПД следующих субъектов ПД:"
          }
          <Br />
          <Ul>
            <li>
              физические лица, оставившие свои ПД в разделе «Хочу консультацию»
              по адресу в сети интернет http://prohorovaconsult.com/booking.
            </li>
          </Ul>
          {"3.15. ПД, обрабатываемые Оператором:"}
          <Br />
          <Ul>
            <li>
              данные, оставленные субъектами ПД на сайте, расположенном по
              адресу в сети Интернет http://prohorovaconsult.com/.
            </li>
          </Ul>
          {
            "3.16. ПД субъектов могут быть получены, проходить дальнейшую обработку и передаваться на хранение только в электронном виде."
          }
          <Br />
          {
            "3.17. ПД субъектов, обрабатываемые с использованием средств автоматизации в разных целях, хранятся в разных папках."
          }
          <Br />
          {
            "3.18. Не допускается хранение и размещение документов, содержащих ПД, в открытых электронных каталогах (файлообменниках) в Информационной системе персональных данных."
          }
          <Br />
          {
            "3.19. Хранение ПД в форме, позволяющей определить субъекта ПД, осуществляется не дольше, чем этого требуют цели их обработки, и они подлежат уничтожению по достижении целей обработки или в случае утраты необходимости в их достижении."
          }
          <Br />
          {
            "3.20. ПД на электронных носителях уничтожаются путем стирания или форматирования носителя."
          }
          <Br />
        </MainText>
        <HeaderText>
          4. Основные права субъекта ПД и обязанности Оператора
        </HeaderText>
        <MainText>
          {
            "4.1. Основные права субъекта ПД. Субъект имеет право на доступ к его персональным данным и следующим сведениям:"
          }
          <Br />
          <Ul>
            <li>подтверждение факта обработки ПД Оператором</li>
            <li>правовые основания и цели обработки ПД</li>
            <li>цели и применяемые Оператором способы обработки ПД</li>
            <li>
              наименование и место нахождения Оператора, сведения о лицах,
              которые имеют доступ к ПД или которым могут быть раскрыты ПД на
              основании договора с Оператором или на основании федерального
              закона
            </li>
            <li>
              сроки обработки персональных данных, в том числе сроки их хранения
            </li>
            <li>
              порядок осуществления субъектом ПД прав, предусмотренных настоящим
              Федеральным законом
            </li>
            <li>
              наименование или фамилия, имя, отчество и адрес лица,
              осуществляющего обработку ПД по поручению Оператора, если
              обработка поручена или будет поручена такому лицу
            </li>
            <li>обращение к Оператору и направление ему запросов</li>
            <li>обжалование действий или бездействия Оператора.</li>
          </Ul>
          {"4.2. Обязанности Оператора. Оператор обязан:"}
          <Br />
          <Ul>
            <li>при сборе ПД предоставить информацию об обработке ПД</li>
            <li>
              в случаях если ПД были получены не от субъекта ПД, уведомить
              субъекта
            </li>
            <li>
              при отказе в предоставлении ПД субъекту разъясняются последствия
              такого отказа
            </li>
            <li>
              опубликовать или иным образом обеспечить неограниченный доступ к
              документу, определяющему его политику в отношении обработки ПД, к
              сведениям о реализуемых требованиях к защите ПД
            </li>
            <li>
              принимать необходимые правовые, организационные и технические меры
              или обеспечивать их принятие для защиты ПД от неправомерного или
              случайного доступа к ним, уничтожения, изменения, блокирования,
              копирования, предоставления, распространения ПД, а также от иных
              неправомерных действий в отношении ПД
            </li>
            <li>
              давать ответы на запросы и обращения субъектов ПД, их
              представителей и уполномоченного органа по защите прав субъектов
              ПД.
            </li>
          </Ul>
        </MainText>
        <HeaderText>
          5. Актуализация, исправление, удаление и уничтожение персональных
          данных, ответы на запросы субъектов на доступ к персональным данным
        </HeaderText>
        <MainText>
          {
            "5.1. Подтверждение факта обработки персональных данных Оператором, правовые основания и цели обработки персональных данных, а также иные сведения, указанные в ч. 7 ст. 14 Закона о персональных данных, предоставляются Оператором субъекту персональных данных или его представителю при обращении либо при получении запроса субъекта персональных данных или его представителя. В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Запрос должен содержать: - номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе; - сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных Оператором; - подпись субъекта персональных данных или его представителя. Запрос может быть направлен в форме электронного документа и подписан электронной подписью в соответствии с законодательством Российской Федерации. Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с требованиями Закона о персональных данных все необходимые сведения или субъект не обладает правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ. Право субъекта персональных данных на доступ к его персональным данным может быть ограничено в соответствии с ч. 8 ст. 14 Закона о персональных данных, в том числе если доступ субъекта персональных данных к его персональным данным нарушает права и законные интересы третьих лиц."
          }
          <Br />
          {
            "5.2. В случае выявления неточных персональных данных при обращении субъекта персональных данных или его представителя либо по их запросу или по запросу Роскомнадзора Оператор осуществляет блокирование персональных данных, относящихся к этому субъекту персональных данных, с момента такого обращения или получения указанного запроса на период проверки, если блокирование персональных данных не нарушает права и законные интересы субъекта персональных данных или третьих лиц. В случае подтверждения факта неточности персональных данных Оператор на основании сведений, представленных субъектом персональных данных или его представителем либо Роскомнадзором, или иных необходимых документов уточняет персональные данные в течение семи рабочих дней со дня представления таких сведений и снимает блокирование персональных данных."
          }
          <Br />
          {
            "5.3. В случае выявления неправомерной обработки персональных данных при обращении (запросе) субъекта персональных данных или его представителя либо Роскомнадзора Оператор осуществляет блокирование неправомерно обрабатываемых персональных данных, относящихся к этому субъекту персональных данных, с момента такого обращения или получения запроса."
          }
          <Br />
          {
            "5.4. При достижении целей обработки персональных данных, а также в случае отзыва субъектом персональных данных согласия на их обработку персональные данные подлежат уничтожению, если:"
          }
          <Br />
          <Ul>
            <li>
              иное не предусмотрено договором, стороной которого,
              выгодоприобретателем или поручителем по которому является субъект
              персональных данных
            </li>
            <li>
              оператор не вправе осуществлять обработку без согласия субъекта
              персональных данных на основаниях, предусмотренных Законом о
              персональных данных или иными федеральными законами
            </li>
            <li>
              иное не предусмотрено другим соглашением между Оператором и
              субъектом персональных данных.
            </li>
          </Ul>
          <Br />
          <Br />
          <Br />
          
        </MainText>
      </Container>
      <Footer />
    </>
  );
};
export default Policy;
